import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.QBooksEmailToVendorSection', {
    formTitle: 'Email to Vendor',
    toggleLabel: 'Automatically email approved Purchase Order to vendor',
    attachmentsLabel: 'Attachments to vendor',
    attachmentsNote:
        'Please notice that the attachments added to the email would also be added to the Request created in QuickBooks Online.',
});
